module.exports = __webpack_public_path__ + "img/ceshi.c9a12c13.jpg";